import { useMask } from "@react-input/mask";
import type { MutableRefObject } from "react";

export const phoneNumberMask = "+1 (___) ___-____";

// Top-level regex for phone number digit matching
const DIGIT_REGEX = /\d/;

const applyMask = (value: string, mask: string): string => {
  const maskChars = mask.split("");
  let valueIndex = 0;

  for (let i = 0; i < maskChars.length && valueIndex < value.length; i++) {
    const currentChar = maskChars[i];
    const valueChar = value[valueIndex];
    if (currentChar === "_" && valueChar !== undefined) {
      maskChars[i] = valueChar;
      valueIndex++;
    }
  }

  const result = maskChars.join("");
  // Find the first remaining underscore (if any) to determine where to cut
  const firstRemainingUnderscore = result.indexOf("_");
  return firstRemainingUnderscore === -1
    ? result
    : result.slice(0, firstRemainingUnderscore);
};

export const applyPhoneNumberMask = (value: string): string => {
  // Strip all non-digit characters first
  let digits = value.replace(/\D/g, "");
  // Remove leading 1 (US country code) if present and we have 11 digits
  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }
  return applyMask(digits, phoneNumberMask);
};

export const stripPhoneNumberMask = (value: string): string => {
  // Remove all non-digit characters
  return value.replace(/\D/g, "");
};

export const getPhoneDigitsForMaskInput = (value: string): string => {
  // Strip all non-digit characters
  let digits = value.replace(/\D/g, "");
  // Remove leading 1 (US country code) if present and we have 11 digits
  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }
  return digits;
};

export const usePhoneNumberMask =
  (): MutableRefObject<HTMLInputElement | null> =>
    useMask({
      mask: phoneNumberMask,
      replacement: { _: DIGIT_REGEX },
    });
